import PropTypes from 'prop-types';

import { Row, RowSpan } from 'components/checkout/caap/Layout';
import { suggestedAddressHighlight as styleSuggestedAddressHighlight } from 'styles/components/checkout/caap/address/suggestedAddresses.scss';

const HighlightedAddress = ({ address = {}, baseAddress = {} }, { testId }) => {
  if (!Object.keys(address).length || !Object.keys(baseAddress).length) {
    return null;
  }

  const {
    addressLine1,
    addressLine2 = '',
    city,
    fullName,
    stateOrRegion,
    postalCode
  } = address;

  const {
    addressLine1: baseAddressLine1,
    city: baseCity,
    stateOrRegion: baseStateOrRegion,
    postalCode: basePostalCode
  } = baseAddress;

  const baseAddressLine2 = baseAddress.addressLine2 || '';

  return (
    <Row data-test-id={testId('highlightedAddress')}>
      <RowSpan span="12">
        <strong>{fullName}</strong>
      </RowSpan>
      <RowSpan span="12">
        <span className={`${addressLine1.toLowerCase() !== baseAddressLine1.toLowerCase() ? styleSuggestedAddressHighlight : ''}`}>{addressLine1}</span>
      </RowSpan>
      <RowSpan span="12">
        {
          addressLine2
            ? <span><span className={`${addressLine2.toLowerCase() !== baseAddressLine2.toLowerCase() ? styleSuggestedAddressHighlight : ''}`}>{addressLine2}</span><br /></span>
            : null
        }
      </RowSpan>
      <RowSpan span="12">
        <span className={`${city.toLowerCase() !== baseCity.toLowerCase() ? styleSuggestedAddressHighlight : ''}`}>
          {city}
        </span>
        {', '}
        <span className={`${stateOrRegion.toLowerCase() !== baseStateOrRegion.toLowerCase() ? styleSuggestedAddressHighlight : ''}`}>
          {` ${stateOrRegion} `}
        </span>
        <span className={`${postalCode.toLowerCase() !== basePostalCode.toLowerCase() ? styleSuggestedAddressHighlight : ''}`}>
          {postalCode}
        </span>
      </RowSpan>
    </Row>
  );
};

HighlightedAddress.contextTypes = {
  testId: PropTypes.func
};

export default HighlightedAddress;
